import { DAY_OF_WEEK_TYPE_LABEL_MAP } from './day-of-week-type-label-map';
import type { DayOfWeekTypes } from './day-of-week-types';

export const DAY_OF_WEEK_TYPE_OPTIONS = Object.entries(DAY_OF_WEEK_TYPE_LABEL_MAP).map(
  ([value, label]) => ({
    value: value as DayOfWeekTypes,
    label,
  }),
);
